export const locale = {
    lang: 'tr',
    data: {
      'MODALES': {
        'ERROR_DATOS':'Bir hata oluştu A-721',
        'VALIDACION':{
          'ERROR1':'Çevirmeden sorunuz var',
          'WARNING-SIN-TRADUCCION':'Lütfen reaktif çevirinizi ekleyin',
          'MODAL-GUARDANDO':'Reaktif Kaydetme'
        },
        'TITULO': 'Bir hata oluştu',
        'TITULOS': {
          'error': 'Bir hata oluştu',
          'adver': 'Uyarı',
          'aviso': 'Uyarı',
          'opSuc': 'İşlem tamamlandı'
        },
        'ACCIONES': {
          'aceptar' : 'Kabul',
          'cancelar': 'İptal',
          'INFORMATIVO': 'Bu mesajı bir daha gösterme'
        },
        'MENSAJES': {
          'NO_FECH_LAN':'Eksik veriler, ürün çıkış tarihini seçin',
          'NO_RESU_ACTI':'Şu anda sonuçlar mevcut değil, lütfen daha sonra tekrar deneyin',
          'OK':'tamam',
          'Something is wrong': 'Bir hata var',
          'password wrong': 'Girdiğiniz şifre hatalıdır',
          'User does not exist': 'Girmiş olduğunuz e-mail sistemde kayıtlı değildir',
          '150': 'Katılımcılar girilmiş durumda :V',
          'Error: user already exist': 'Kaydedilmeye çalışılan kullanıcı daha önce sistemde tanımlanmış',
          'CONEX': {
            'SIN': 'Cihazınız İnternet bağlantısını kaybetti\n\nPlatformu kullanmaya devam etmek için cihazınızı İnternet\'e bağlayın',
            'CON': 'Cihazınız İnternet bağlantısını kurtardı\n\nArtık platformu kullanmaya devam edebilirsiniz'
          },
          'WIZARD': {
            'CERTIFICAR' : {
              'RESTRICCIONES': {
                'rest1': 'Bu bölüme erişim için anket <b>dil(ler)inin</b> belirlenmesi gerekmektedir.',
                'rest2': 'Bu bölüme erişim için önceki adımları tamamlamanız gerekmektedir.',
                'rest3': 'Bu bölüme erişim için anket uygulama <b>tarihinin</b> belirlenmesi gerekmektedir.',
                'rest4': 'Bu bölüme erişim için çalışanlara <b>e-mail gönderimlerini</b> yapmış ve anketi başlatmış olmanız gerekmektedir.'
              },
              'IDIOMAS': {
                'NADA': 'Henüz ana ve ek dilleri seçmediniz',
                'NODEFAULT': 'Henüz ana dili seçmediniz',
                'NOADICIONAL': 'Seçmiş olduğunuz ek bir dil yok',
                'COMPLETAR': 'Mevcut dil seçiminizle bu aşamayı tamamlamak istediğinizden emin misiniz?',
                '210': 'Bu aşama doğru şekilde tamamlandı.',
                'COMPLETADO': 'Bu adımı daha önce tamamladınız',
                'RESTRICCION': 'İlgili adımı tamamladığınızdan bu işlemi yerine getirmeniz mümkün değildir',
                'INFORMATIVO': 'Bu bölümde anketin ana dilini ve gerekiyorsa diğer ek dilleri seçebilirsiniz.',
                'ARCHIVOCOMFIRM': 'Uyarı! Kodlama çakışmalarını önlemek için Excel dosyasını tek bir işletim sisteminde çalıştığınızdan emin olun.',
                'BOTONTEXTO':'Anladım',
              },
              'TEMPLATE': {
                // 'NADA': 'Aún no ha realizado la selección de los idiomas principal y adicionales',
                // 'NODEFAULT': 'Aún no ha seleccionado el idioma principal',
                // 'NOADICIONAL': 'Aún no ha seleccionado idiomas adicionales',
                // 'COMPLETAR': '¿Está seguro de completar el paso con la selección actual de idiomas?',
                // '210': 'El paso se completó correctamente',
                // 'COMPLETADO': 'Ya ha completado este paso',
                // 'RESTRICCION': 'No es posible realizar esta acción una vez que ya ha completado este paso',
                'INFORMATIVO': 'Bu bölümde şablonda değişiklik yapabilirsiniz.',
                // 'ARCHIVOCOMFIRM':'¡Advertencia! Asegúrate de trabajar el archivo de Excel en un único sistema operativo para evitar conflictos de codificación',
                // 'BOTONTEXTO':'Enterado',

                // 'TITULO_DESBLOQUEAR': '<span>¿Está seguro de reabrir el paso de idiomas, tenga en cuenta que esto <font color="red">reiniciará</font> su producto actual y borrará toda la información que haya agregado a las secciones?</span>',
                // 'BOTON_CONFIRM': 'Sí, reabrir',
                // 'BOTON_CANCEL': 'Cancelar',
                // 'SUCCES': 'El paso ha sido reabierto con éxito',
                // 'BLOQUEADO': 'El paso ya esta abierto',
                // 'CERRAR': 'Cerrar'
              },
              'NPS': {
                'NADA': 'Herhangi bir NPS oluşturmadınız veya seçeneği NPS olmadan işaretlemediniz',
                'COMPLETAR': 'Mevcut NPS\'nizle adımı tamamlayabileceğinizden emin misiniz?',
                '219': 'Bu adım başarıyla tamamlandı',
                '220': 'Bu adım başarıyla tamamlandı',
                'COMPLETADO': 'Bu adımı zaten tamamladınız',
                'RESTRICCION': 'Bu adımı tamamladıktan sonra bu işlemi gerçekleştirmek mümkün değildir',
                'INFORMATIVO': 'Bu bölümde anket için NPS\'nizi değiştirebilirsiniz',
                'FALTANTES_TRADUCCIONES': 'Tüm soruların çevirilerini henüz tamamlamadınız',
                'FALTANTES_SECCIONES_ESPECIALES': 'Özel bölümün anahtarını henüz girmediniz',
                'FALTANTES_RESPUESTAS': 'Bu adımı henüz tamamlayamazsınız, tüm çoktan seçmeli soruların en az iki cevap seçeneği olmalıdır',
                'SIN_PREGUNTAS': 'Adımı tamamlamak için en az bir soru eklemeniz gerekiyor',
                'SIN_GRUPOS': 'Adımı tamamlamak için içinde soru bulunan en az bir soru grubu eklemelisiniz',
                'FALTANTES': 'NPS\'nizi doldurmayı henüz tamamlamadınız'
              },
              'REACTIVOS': {
                'NADA': 'Herhangi bir reaktif oluşturmadınız veya seçeneği reaktif olmadan işaretlediniz',
                'COMPLETAR': 'Seçmiş olduğunuz sorularla bu adımı tamamlamak istediğinizden emin misiniz?',
                '218': 'Bu adım başarıyla tamamlandı',
                'COMPLETADO': 'Bu adımı zaten tamamladınız',
                'RESTRICCION': 'Bu adımı tamamladıktan sonra bu işlemi gerçekleştirmek mümkün değildir',
                'INFORMATIVO': 'Bu bölümde anketinizde bulunmasını istediğiniz soruları tanımlayabilirsiniz',
                'FALTANTES_TRADUCCIONES': 'Tüm soruların çevirilerini henüz tamamlamadınız',
                'FALTANTES_SECCIONES_ESPECIALES': 'Özel bölümün anahtarını henüz girmediniz',
                'FALTANTES_RESPUESTAS': 'Bu adımı henüz tamamlayamazsınız, tüm çoktan seçmeli soruların en az iki cevap seçeneği olmalıdır',
                'SIN_PREGUNTAS': 'Adımı tamamlamak için en az bir soru eklemeniz gerekiyor',
                'SIN_GRUPOS': 'Adımı tamamlamak için içinde soru bulunan en az bir soru grubu eklemelisiniz',
                'FALTANTES': 'Reaktiflerinizi doldurmayı henüz tamamlamadınız'
              },
              'FORALL': {
                'NADA': '4ALL uygulamalarını henüz doldurmadınız',
                'COMPLETAR': 'Tanımlamış olduğunuz For All uygulamalarıyla bu adımı tamamlamak istediğinizden emin misiniz?',
                '212': 'Aşama başarıyla tamamlandı',
                'COMPLETADO': 'Bu adımı daha önce tamamladınız',
                'RESTRICCION': 'İlgili adımı tamamladığınızdan bu işlemi yerine getirmeniz mümkün değildir',
                'INFORMATIVO': 'Bu bölüm, şirketin tüm çalışanlara yönelik insan kaynakları uygulamaları hakkında bilgi almaya ve bu uygulamaların sorulaştırılmasına yöneliktir',
                'FALTANTES_TRADUCCIONES': 'Tüm soruların çevirilerini henüz tamamlamadınız',
                'FALTANTES_SECCIONES_ESPECIALES': 'Özel bölümün anahtarını henüz girmediniz',
                'FALTANTES_RESPUESTAS': 'Bu adımı henüz tamamlayamazsınız, tüm çoktan seçmeli soruların en az iki cevap seçeneği olmalıdır',
                'SIN_PREGUNTAS': 'Adımı tamamlamak için en az bir soru eklemeniz gerekiyor',
                'SIN_GRUPOS': 'Adımı tamamlamak için içinde soru bulunan en az bir soru grubu eklemelisiniz',
                'NADA_TRA':'4ALL uygulamalarınızın çevirisini henüz bitirmediniz'
              },
              'CONTROL': {
                'NADA': 'Herhangi bir kontrol sorusu oluşturmadınız veya seçeneği kontrolsüz olarak işaretlemediniz',
                'COMPLETAR': 'Mevcut kontrol sorunuzla adımı tamamlamak istediğinizden emin misiniz?',
                '221': 'Aşama başarıyla tamamlandı',
                'COMPLETADO': 'Bu adımı daha önce tamamladınız',
                'RESTRICCION': 'İlgili adımı tamamladığınızdan bu işlemi yerine getirmeniz mümkün değildir',
                'INFORMATIVO': 'Bu bölümde anket kontrol sorunuzu değiştirebilirsiniz',
                'FALTANTES_TRADUCCIONES': 'Tüm soruların çevirilerini henüz tamamlamadınız',
                'FALTANTES_SECCIONES_ESPECIALES': 'Özel bölümün anahtarını henüz girmediniz',
                'FALTANTES_RESPUESTAS': 'Bu adımı henüz tamamlayamazsınız, tüm çoktan seçmeli soruların en az iki cevap seçeneği olmalıdır',
                'SIN_PREGUNTAS': 'Adımı tamamlamak için en az bir soru eklemeniz gerekiyor',
                'SIN_GRUPOS': 'Adımı tamamlamak için içinde soru bulunan en az bir soru grubu eklemelisiniz',
                'FALTANTES': 'Kontrol sorunuzu doldurmayı henüz tamamlamadınız'
              },
              'DEMOGRAFICOS': {
                'NADA': 'Henüz demografiyi seçmediniz',
                'COMPLETAR': 'Tanımlamış olduğunuz demografik sorularla bu adımı tamamlamak istediğinizden emin misiniz?',
                '213': 'Aşama başarıyla tamamlandı',
                'COMPLETADO': 'Bu adımı daha önce tamamladınız',
                'RESTRICCION': 'İlgili adımı tamamladığınızdan bu işlemi yerine getirmeniz mümkün değildir',
                'FALTANTES_TRADUCCIONES': 'Tüm soruların çevirilerini henüz tamamlamadınız',
                'FALTANTES_SECCIONES_ESPECIALES': 'Özel bölümün anahtarını henüz girmediniz',
                'FALTANTES_RESPUESTAS': 'Bu adımı henüz tamamlayamazsınız, tüm çoktan seçmeli soruların en az iki cevap seçeneği olmalıdır',
                'SIN_PREGUNTAS': 'Adımı tamamlamak için en az bir soru eklemeniz gerekiyor',
                'SIN_GRUPOS': 'Adımı tamamlamak için içinde soru bulunan en az bir soru grubu eklemelisiniz',
                'INFORMATIVO': 'Bu bölüm, çalışanların cevaplamasını istediğiniz demografik soruların belirlenmesine yöneliktir '
              },
              'ABIERTAS': {
                'NADA': 'Açık bir soru oluşturmadınız veya açık sorular olmadan seçeneği işaretlemediniz',
                'COMPLETAR': 'Tanımlamış olduğunuz açık sorularla bu adımı tamamlamak istediğinizden emin misiniz?',
                '220': 'Adım başarıyla tamamlandı',
                '219': 'Adım başarıyla tamamlandı',
                'COMPLETADO': 'Bu adımı zaten tamamladınız',
                'RESTRICCION': 'Bu adımı tamamladıktan sonra bu işlemi gerçekleştirmek mümkün değildir',
                'INFORMATIVO': 'Bu bölüm, çalışanlardan yazılı geri bildirim almak istediğiniz soruların belirlenmesine yöneliktir',
                'FALTANTES_TRADUCCIONES': 'Tüm soruların çevirilerini henüz tamamlamadınız',
                'FALTANTES_SECCIONES_ESPECIALES': 'Özel bölümün anahtarını henüz girmediniz',
                'FALTANTES_RESPUESTAS': 'Bu adımı henüz tamamlayamazsınız, tüm çoktan seçmeli soruların en az iki cevap seçeneği olmalıdır',
                'SIN_PREGUNTAS': 'Adımı tamamlamak için en az bir soru eklemeniz gerekiyor',
                'SIN_GRUPOS': 'Adımı tamamlamak için içinde soru bulunan en az bir soru grubu eklemelisiniz',
                'FALTANTES': 'Açık sorularınızı doldurmayı henüz tamamlamadınız'
              },
              'ADICIONALES': {
                'NADA': 'Ek soru oluşturmadınız veya ek soru sormadan seçeneği işaretlemediniz',
                'COMPLETAR': 'Mevcut ek sorularla bu aşamayı tamamlamak istediğinizden emin misiniz?',
                '214': 'Aşama başarıyla tamamlandı',
                'COMPLETADO': 'Bu adımı daha önce tamamladınız',
                'RESTRICCION': 'İlgili adımı tamamladığınızdan bu işlemi yerine getirmeniz mümkün değildir',
                'FALTANTES_TRADUCCIONES': 'Tüm soruların çevirilerini henüz tamamlamadınız',
                'FALTANTES_SECCIONES_ESPECIALES': 'Özel bölümün anahtarını henüz girmediniz',
                'FALTANTES_RESPUESTAS': 'Bu adımı henüz tamamlayamazsınız, tüm çoktan seçmeli soruların en az iki cevap seçeneği olmalıdır',
                'SIN_PREGUNTAS': 'Adımı tamamlamak için en az bir soru eklemeniz gerekiyor',
                'SIN_GRUPOS': 'Adımı tamamlamak için içinde soru bulunan en az bir soru grubu eklemelisiniz',
                'INFORMATIVO': 'Bu bölümde ankete özel sorular ekleyebilirsiniz.'
              },
              'COLABORADORES': {
                'NADA': 'Katılımcı verisini yüklemediniz',
                'COMPLETAR': 'Yüklemiş olduğunuz katılımcı verileriyle bu adımı tamamlamak istediğinizden emin misiniz?',
                '211': 'Aşama başarıyla tamamlandı',
                'COMPLETADO': 'Bu adımı daha önce tamamladınız',
                'RESTRICCION': 'İlgili adımı tamamladığınızdan bu işlemi yerine getirmeniz mümkün değildir',
                'INFORMATIVO': 'Bu bölüm, e-mail yoluyla anket katılım daveti gönderilecek çalışanlara ait verinin hazırlanması ve Cultural GO platformuna yüklenmesine yöneliktir',
                'ARCHIVOCOMFIRM':'Uyarı! Kodlama çakışmalarını önlemek için Excel dosyasını tek bir işletim sisteminde çalıştığınızdan emin olun, teşekkürler.',
                'ACTUALIZAR': 'Ortak çalışanlar ankete doğru şekilde eklendi'
              },
              'PROGRAMACION': {
                'NADA': 'Henüz randevu almadınız',
                'COMPLETAR': 'Mevcut tarihle bu aşamayı tamamlamak istediğinizden emin misiniz?',
                'GENERAR': 'Bu aşamayı tamamlamak istediğinizden emin emisiniz?',
                '215': 'Aşama başarıyla tamamlandı',
                '217': 'Aşama başarıyla tamamlandı', //CERTIFICAR2.0
                'COMPLETADO': 'Bu adımı daha önce tamamladınız',
                'FECHALANZAMIENTO': 'Çıkış tarihinizi henüz girmediniz',
                'RESTRICCION': 'İlgili adımı tamamladığınızdan bu işlemi yerine getirmeniz mümkün değildir',
                'INFORMATIVO': 'Bu bölüm, anket başlatma tarihinin ve hatırlatma gönderim tarihlerinin belirlenmesine yöneliktir',
                'INFORMATIVO2': 'Bu bölüm, anket gönderme tarihlerini belirler Nabız Kontrolü',
                'GUARDA-OK':'Tarih başarıyla kaydedildi',
                'OK':'tamam',
                'NOT_MESS_COM':'Bu işleve izin verilmiyor',
                'DETEC_CAMBIOS_SECCIONES':'Bölümlerin konfigürasyonunda değişiklikler tespit edildi, anketi tekrar oluşturun',
              },
              'ENVIO': {
                'NADA': 'Henüz test anketi gönderimi yapmadınız',
                'NADA_OPCION': 'Davetin e-posta ile gönderilip gönderilmeyeceğini henüz yapılandırmadınız',
                'COMPLETAR': 'Bu adımı tamamlamak istediğinizden emin misiniz?',
                '216': 'Aşama başarıyla tamamlandı',
                'COMPLETADO': 'Bu adımı daha önce tamamladınız',
                'RESTRICCION': 'İlgili adımı tamamladığınızdan bu işlemi yerine getirmeniz mümkün değildir',
                'INFORMATIVO': 'Bu bölümde anket tamamlama daveti gönderimi yapılmıştır.'
              },
              'CONFIRMACION': {
                // 'NADA': 'Aún no ha realizado el envío de la invitación a la encuesta a sus colaboradores',
                // 'NADA_OPCION': 'Aún no ha configurado si el envío de la invitación se hará por correo electrónico',
                // 'COMPLETAR': '¿Está seguro de completar el paso?',
                // '216': 'El paso se completó correctamente',
                // 'COMPLETADO': 'Ya ha completado este paso',
                // 'RESTRICCION': 'No es posible realizar esta acción una vez que ya ha completado este paso',
                 'INFORMATIVO': 'Bu bölümde anketi etkinleştirebilir veya devre dışı bırakabilirsiniz',
                // 'TITULO_DESBLOQUEAR': '¿Está seguro de reabrir el paso de envío de correos?',
                // 'BOTON_CONFIRM': 'Sí, reabrir',
                // 'BOTON_CANCEL': 'Cancelar',
                // 'SUCCES': 'El paso ha sido reabierto con éxito',
                // 'BLOQUEADO': 'El paso ya esta abierto',
                // 'CERRAR': 'Cerrar'
              },
              'CIERRE': {
                'NADA': 'Anket henüz tamamlanmadı.',
                'COMPLETAR': 'Bu aşamayı tamamlamak istediğinizden emin emisiniz?',
                '217': 'Aşama başarıyla tamamlandı',
                'COMPLETADO': 'Bu adımı daha önce tamamladınız',
                'RESTRICCION': 'İlgili adımı tamamladığınızdan bu işlemi yerine getirmeniz mümkün değildir',
                'INFORMATIVO': 'Bu bölümde, anketin şu anki ilerlemesine ve anketin erken kapanmasına danışılabilir.',
                'INFORMATIVO2': 'Bu bölümde anket katılım durumunu takip edebilir, anketinizi sonlandırabilirsiniz.'
              }
            },
            'NOM35': {
              'CENTROS': {
                'AUTOLOGIN': {
                  'TITULO': 'Uyarı',
                  'INFO': 'Uyarı\n\nOturumunuz kapatılacak ve platform seçilen iş merkezi olarak giriş yapmaya devam edecek\n\nSeçilen iş merkezi olarak giriş yapmayı onaylıyor musunuz?',
                  'INFOODS': 'Uyarı\n\nOturumunuz kapanacak ve platform seçilen şirket olarak giriş yapmaya devam edecektir.\n\nSeçilen şirket olarak giriş yapmayı onaylıyor musunuz?'
                }
              }
            },
            'FOCUS':{
              'MODAL-AUNAUTORIZACION':'Henüz yetkilendirilmedi',
              'BTN-ENTERADO':'GİRİŞ',
              'MODAL-AUTORIZACION':'Anketiniz doğrulamak için gönderildi',


            },
          }
        },
        'ERRORES': {
          'Ocurrió un error desconocido': 'Bilgisayarınız veya cihazınız platformla bağlantı hatası gösteriyor, lütfen daha sonra tekrar erişmeyi deneyin',
          '102': 'Girmiş olduğunuz e-mail CulturalGO platformunda kayıtlı değil',
          '103': 'Girmiş olduğunuz şifre geçersiz',
          'verifyToken_3': '<span>Platformda bu nedenle ve bilgi kaybını önlemek için kısa süre önce bir güncelleme yapıldı, ardından oturumunuz kapatılacak<br><br>Platformun düzgün çalışmasını sağlamak için <font color="red">tarayıcınız otomatik olarak güncellenecektir</font></span>',
          'tokenActLogin': '<span>Platform kısa bir süre önce bir güncelleme yaptı, bu nedenle ve platformun doğru çalışmasını sağlamak için <font color="red">tarayıcınız otomatik olarak güncellenecek</font>, daha sonra platforma normal şekilde erişebilirsiniz</span>',
          'Demo keys out of stock': 'Anket demo kullanıcıları tükendi',
          'Keys Out Of Stock': 'Anket demo kullanıcıları tükendi',
          'Error: Please Recreate Survey':'Sorularda değişiklikler tespit edildi.\n\n Devam etmek için lütfen anketi yeniden oluşturun.',
          'IT Manager Not Found':'E-posta BT yöneticisine gönderilmedi.\n\n e-postayı girin ve manuel olarak gönderin.',
          'NO_PROCC_PROD_ASO':'İlişkili ürün şu anda işlenmedi',
          'ERR_PROCC_PROD_ACT':'SQL de kullanıcılar güncellenirken hata oluştu',
          '300':'Girilen e-postanın erişim izinleri yok',
        },
        'ELIMINAR':{
          'MENSAJETEXTO1': '<span>Şirketin elden çıkarıldığını onaylamak için ',
          'MENSAJETEXTO2': ', metin kutusuna şirket adını girin</span>',
          'SALIR': 'çıkış',
          'VALIDAR': 'Şirketi onaylayın',
          'ERRORNOMBREEMPRESA': 'Girilen şirketin adı, silinecek şirketin adıyla eşleşmiyor',
          'MENSAJE': 'Emin misiniz?\n\nŞirketi silmek üzeresiniz ',
          'CANCELAR': 'İptal etmek',
          'CONFIRMAR': 'Evet, kaldır',
          'SUCCES': 'Şirket elendi',
          'CERRAR': 'Kapat'
        }
      }
    }
};
